import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Configure i18next instance
i18n
  // Load translations via HTTP from /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next);

// Define initialization options
const i18nOptions = {
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React escapes by default
  },
  backend: {
    // {{lng}} = language code (e.g., 'en')
    // {{ns}} = namespace (defaults to 'translation')
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
};

// Export the configured instance (not yet initialized)
export const i18nInstance = i18n;

// Export an async function to initialize the instance
export const initializeI18n = async () => {
  await i18nInstance.init(i18nOptions);
};
